import nodeApi from '../utils/nodeApiClient';

const saleOrdersApi = {
  list: (params) => nodeApi.get('/sale-orders', { params }),
  getById: (id) => nodeApi.get(`/sale-orders/${id}`),
  create: (data) => nodeApi.post('/sale-orders', data),
  update: (id, data) => nodeApi.put(`/sale-orders/${id}`, data),
  remove: (id) => nodeApi.delete(`/sale-orders/${id}`),

  getDetails: (id) => nodeApi.get(`/sale-orders/${id}/details`),
  getOutstanding: (id) => nodeApi.get(`/sale-orders/${id}/outstanding`),
  getServiceInvoiceHistory: (detailId) => nodeApi.get(`/sale-orders/service-details/${detailId}/invoice-history`)
};

export default saleOrdersApi;
